import React, { Component } from "react";
import { Link } from "react-router-dom";

class MenuProducao extends Component {
  render() {
    return (
      <li className="nav-item">
        <Link to="/atendimento/consulta" className="nav-link">
          <i className="link-icon icon-book-open" />
          <span className="menu-title">Produção</span>
          <i className="menu-arrow" />
        </Link>
        <div className="submenu">
          <ul className="submenu-item">
            <li className="nav-item">
              <Link className="nav-link" to="/atendimento/consulta">
                Consultar Atendimentos
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/reuniao/consulta">
                Consultar Atividades / Reuniões
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={{ pathname: "/atendimento/cadastro", state: "refresh" }}>
                Novo Atendimento
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={{ pathname: "/reuniao/cadastro", state: "refresh" }}>
                Nova Atividade / Reunião
              </Link>
            </li>
          </ul>
        </div>
      </li>
    );
  }
}

export default MenuProducao;
